import { MahaffeyOperationsClient } from '../contracts/client-adapter.js';
import type { JsonValue, RpcResponse, SupabaseRpcTransport } from '../contracts/reference-types.js';
import { supabase } from './supabase';
const transport: SupabaseRpcTransport = {
  async rpc<T = JsonValue>(fn: string, args?: Record<string, unknown>): Promise<RpcResponse<T>> {
    const result = await supabase.rpc(fn, args ?? {});
    return { data: (result.data ?? null) as T | null, error: result.error ? { message: result.error.message, code: result.error.code, details: result.error.details, hint: result.error.hint } : null };
  },
};
export const api = new MahaffeyOperationsClient(transport);
